// extracted by mini-css-extract-plugin
export default {"content":"PrivacyPolicy_content__Xj3yr","contentValue":"PrivacyPolicy_contentValue__bGOcD"};